"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const client_1 = require("@apollo/client");
const createHttpLink_1 = (0, tslib_1.__importDefault)(require("./createHttpLink"));
const onError_1 = (0, tslib_1.__importDefault)(require("./onError"));
const createWsLink_1 = (0, tslib_1.__importDefault)(require("./createWsLink"));
const apollo_utilities_1 = require("apollo-utilities");
const isSsrMode_1 = (0, tslib_1.__importDefault)(require("./isSsrMode"));
const isOperationDefinition = (definition) => {
    return definition && definition.kind === 'OperationDefinition';
};
function createLink(options) {
    const links = [(0, onError_1.default)(options)];
    const ssrMode = (0, isSsrMode_1.default)(options);
    if (options.useSubscriptions && !ssrMode) {
        const httpLink = (0, createHttpLink_1.default)(options);
        const wsLink = (0, createWsLink_1.default)(options);
        const link = (0, client_1.split)(({ query }) => {
            const definition = (0, apollo_utilities_1.getMainDefinition)(query);
            if (!isOperationDefinition(definition)) {
                return false;
            }
            const { kind, operation } = definition;
            return kind === 'OperationDefinition' && operation === 'subscription';
        }, wsLink, httpLink);
        links.push(link);
    }
    else {
        links.push((0, createHttpLink_1.default)(options));
    }
    return client_1.ApolloLink.from(links);
}
exports.default = createLink;
